import { useEffect, useState } from "react";
import c3 from "c3";
import "c3/c3.css";
import * as d3 from "d3";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import "./chartLine.css";

const ChartLine = ({ allData, chartType }) => {
  const [selectedSizeFormat, setSelectedSizeFormat] = useState("TB");
  const [updateDone, setUpdateDone] = useState(false);

  useEffect(() => {
    if (allData.length > 0) {
      updateHitsChart();
      updateSizeChart();
    } else {
      setUpdateDone(false);
    }
  }, [allData, updateDone]);

  useEffect(() => {
    updateSizeChart();
  }, [selectedSizeFormat]);

  const formatSize = (bytes) => {
    let formattedSize;
    if (selectedSizeFormat === "GB") {
      formattedSize = (bytes / 1000000000).toFixed(2);
    } else if (selectedSizeFormat === "TB") {
      formattedSize = (bytes / 1000000000000).toFixed(2);
    } else if (selectedSizeFormat === "MB") {
      formattedSize = (bytes / 1000000).toFixed(2);
    }
    return formattedSize;
  };

  const handleChangeSizeFormat = (e) => {
    setSelectedSizeFormat(e.target.value);
  };

  const updateHitsChart = () => {
    const columnX = ["Dates"];
    const columnYHits = ["Hits"];

    let timeFormat;
    const firstDate = allData[0]?.Description?.toString();
    if (chartType === "Daily" && firstDate?.length === 10) {
      timeFormat = "%Y-%m-%d";
    } else if (chartType === "Monthly" && firstDate?.length === 7) {
      timeFormat = "%Y-%m";
    } else {
      return;
    }

    allData.forEach((d) => {
      columnX.push(d.Description);
      columnYHits.push(d.Hits);
    });

    c3.generate({
      bindto: "#chartHits",
      data: {
        x: "Dates",
        xFormat: timeFormat,
        columns: [columnX, columnYHits],
      },
      grid: {
        x: {
          show: true,
        },
        y: {
          show: true,
        },
      },
      axis: {
        x: {
          type: "timeseries",
          tick: {
            format: timeFormat,
          },
        },
        y: {
          tick: {
            format: d3.format(","),
          },
        },
      },
    });

    setUpdateDone(true);
  };

  const updateSizeChart = () => {
    const columnX = ["Dates"];
    const columnYSize = ["Size"];

    let timeFormat;
    if (chartType === "Daily") {
      timeFormat = "%Y-%m-%d";
    } else if (chartType === "Monthly") {
      timeFormat = "%Y-%m";
    } else {
      return;
    }

    allData.forEach((d) => {
      columnX.push(d.Description);
      columnYSize.push(formatSize(d.Size));
    });

    c3.generate({
      bindto: "#chartSize",
      data: {
        x: "Dates",
        xFormat: timeFormat,
        columns: [columnX, columnYSize],
      },
      grid: {
        x: {
          show: true,
        },
        y: {
          show: true,
        },
      },
      axis: {
        x: {
          type: "timeseries",
          tick: {
            format: timeFormat,
          },
        },
        y: {
          tick: {
            format: d3.format(","),
          },
        },
      },
    });

    setUpdateDone(true);
  };

  const sizeSelection = (
    <span className="radio-span">
      <input
        type="radio"
        id="radio1"
        name="chart-size-format"
        value="TB"
        onChange={handleChangeSizeFormat}
        checked={selectedSizeFormat === "TB"}
      />
      <label htmlFor="radio1">TB</label>
      <input
        type="radio"
        id="radio2"
        name="chart-size-format"
        value="GB"
        onChange={handleChangeSizeFormat}
        checked={selectedSizeFormat === "GB"}
      />
      <label htmlFor="radio2">GB</label>
      <input
        type="radio"
        id="radio3"
        name="chart-size-format"
        value="MB"
        onChange={handleChangeSizeFormat}
        checked={selectedSizeFormat === "MB"}
      />
      <label htmlFor="radio3">MB</label>
    </span>
  );

  return (
    <>
      {updateDone ? (
        <Card header="Graphs" className="p-4 mt-4">
          <div>
            <b>Hits</b>
            <div id="chartHits"></div>
          </div>
          <div>
            <b>Size</b>
            {sizeSelection}
            <div id="chartSize"></div>
          </div>
        </Card>
      ) : null}
    </>
  );
};

ChartLine.propTypes = {
  allData: PropTypes.array,
  chartType: PropTypes.string,
};

export default ChartLine;
